(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swan-service-help"] && !Shopify.designMode) return;
  try {
    
(() => {
  function chatControl(root) {
    const control = root.querySelector('button[part~="activator"], button[aria-label="Open chat"], button.chat-toggle');
    if (control) return control;
    for (const element of root.querySelectorAll('*')) {
      if (element.shadowRoot) {
        const nested = chatControl(element.shadowRoot);
        if (nested) return nested;
      }
    }
    return null;
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-swan-open-chat]');
    if (!trigger) return;
    const status = trigger.closest('article').querySelector('[data-swan-chat-status]');
    for (const host of document.querySelectorAll('shopify-chat, shopify-agent-shell, shopify-agent-runtime, inbox-online-store-chat')) {
      const control = chatControl(host.shadowRoot || host);
      if (control) {
        status.hidden = true;
        if (control.getAttribute('aria-expanded') !== 'true') control.click();
        return;
      }
    }
    status.hidden = false;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swan-special-order"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const get = s => root.querySelector(s), form = get('form'), search = get('[data-product-search]'), results = get('[data-search-results]'), status = get('[data-search-status]'), selected = get('[data-selected-product]'), variants = get('[data-variant-select]'), variantWrap = get('[data-variant-wrap]'), cutting = get('[data-cutting]'), cutDetails = get('[data-cut-details]');
    const words = JSON.parse(get('[data-special-order-strings]').textContent);
    let timer, searchController, productController, version = 0, options = [], selectedProduct = null;
    const element = (tag, cls, text) => { const el = document.createElement(tag); if(cls) el.className = cls; if(text) el.textContent = text; return el; };
    const localProductURL = raw => { try { const url = new URL(raw, location.origin); return url.origin === location.origin && /\/products\/[^/]+$/.test(url.pathname) ? url : null; } catch { return null; } };
    const imageURL = raw => { if(!raw) return ''; try { const url = new URL(raw, location.origin); return url.protocol === 'https:' ? url.href : ''; } catch { return ''; } };
    function closeResults() { results.hidden = true; results.replaceChildren(); }
    function updateWhatsApp() {
      const lines = ['Hi Swan Canada, I would like a Special Order quote.'];
      if(search.value.trim()) lines.push('Product: '+search.value.trim());
      if(get('[data-product-url]').value) lines.push(get('[data-product-url]').value);
      if(!variants.disabled && !variantWrap.hidden && variants.value) lines.push('Option: '+variants.value);
      if(get('[data-quantity]').value) lines.push('Individual pieces/panels: '+get('[data-quantity]').value);
      lines.push('Cutting: '+cutting.value);
      if(!cutDetails.hidden) {
        const length = get('[data-length]').value, width = get('[data-width]').value, unit = get('[data-unit]').value;
        if(length || width) lines.push('Requested size: '+(length || '?')+' long × '+(width || '?')+' wide ('+unit+')');
      }
      if(get('[data-notes]').value.trim()) lines.push('Details: '+get('[data-notes]').value.trim().slice(0,1500));
      get('[data-whatsapp]').href = 'https://wa.me/19056294373?text='+encodeURIComponent(lines.join('\n'));
    }
    function resetProduct() {
      productController?.abort(); selectedProduct = null; selected.hidden = true; options = []; variants.replaceChildren(); variants.disabled = true; variantWrap.hidden = true;
      get('[data-product-url]').value = ''; get('[data-product-sku]').value = '';
    }
    function syncVariant() { const option = options[variants.selectedIndex]; get('[data-product-sku]').value = option?.sku || ''; updateWhatsApp(); }
    async function choose(product) {
      version++; searchController?.abort(); resetProduct(); selectedProduct = product; search.value = product.title; closeResults(); status.textContent = words.selected;
      const url = localProductURL(product.url); if(!url) return;
      const cleanURL = location.origin + url.pathname;
      get('[data-product-url]').value = cleanURL; get('[data-selected-title]').textContent = product.title; get('[data-selected-link]').href = cleanURL;
      const img = get('[data-selected-image]'), image = imageURL(product.image || product.featured_image?.url || '');
      img.hidden = !image; if(image) img.src = image;
      selected.hidden = false; updateWhatsApp();
      productController = new AbortController(); const ownVersion = version;
      try {
        const response = await fetch(url.pathname + '.js', {signal:productController.signal,credentials:'same-origin'}); if(!response.ok) throw new Error('product');
        const data = await response.json(); if(ownVersion !== version) return;
        options = data.variants || [];
        options.forEach(v => { const option = element('option','',v.title); option.value = v.title; variants.append(option); });
        variantWrap.hidden = options.length < 2 && (!options[0] || options[0].title === 'Default Title'); variants.disabled = options.length === 0;
        syncVariant();
      } catch(error) { if(error.name !== 'AbortError' && ownVersion === version) status.textContent = words.variant_error; }
    }
    async function find() {
      clearTimeout(timer); searchController?.abort(); const query = search.value.trim();
      if(query.length < 2) {closeResults(); status.textContent = words.enter; return;}
      if(localProductURL(query)) {closeResults(); status.textContent = ''; updateWhatsApp(); return;}
      const ownVersion = ++version; searchController = new AbortController(); status.textContent = words.loading;
      const endpoint = new URL(root.dataset.searchUrl+'.json',location.origin);
      endpoint.search = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'8','resources[options][unavailable_products]':'show','resources[options][fields]':'title,product_type,variants.title,variants.sku'}).toString();
      try {
        const response = await fetch(endpoint,{signal:searchController.signal,credentials:'same-origin'}); if(!response.ok) throw new Error('search');
        const data = await response.json(); if(ownVersion !== version) return;
        const products = (data.resources?.results?.products || []).filter(p=>localProductURL(p.url)); closeResults();
        products.forEach(product => { const li = element('li'), button = element('button','sso-result'); button.type='button'; const source = imageURL(product.image || product.featured_image?.url || ''); if(source){const img=element('img');img.src=source;img.alt='';img.width=46;img.height=46;button.append(img);} button.append(element('span','',product.title)); button.addEventListener('click',()=>choose(product));li.append(button);results.append(li); });
        results.hidden = !products.length; status.textContent = products.length ? words.found : words.none;
      } catch(error) { if(error.name!=='AbortError' && ownVersion===version){closeResults();status.textContent=words.error;} }
    }
    search.addEventListener('input',()=>{version++;resetProduct();closeResults();clearTimeout(timer);searchController?.abort();status.textContent='';timer=setTimeout(find,300);updateWhatsApp();});
    search.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();find();}if(e.key==='Escape')closeResults();if(e.key==='ArrowDown'&&!results.hidden){e.preventDefault();results.querySelector('button')?.focus();}});
    results.addEventListener('keydown',e=>{const buttons=[...results.querySelectorAll('button')],i=buttons.indexOf(document.activeElement);if(e.key==='ArrowDown'){e.preventDefault();buttons[Math.min(i+1,buttons.length-1)]?.focus();}if(e.key==='ArrowUp'){e.preventDefault();if(i<=0)search.focus();else buttons[i-1]?.focus();}if(e.key==='Escape'){closeResults();search.focus();}});
    get('[data-search-button]').addEventListener('click',find);
    get('[data-clear-product]').addEventListener('click',()=>{version++;resetProduct();search.value='';status.textContent='';search.focus();updateWhatsApp();});
    variants.addEventListener('change',syncVariant);
    function syncCutting() {cutDetails.hidden=cutting.value==='No cutting requested';cutDetails.querySelectorAll('input,select').forEach(input=>input.disabled=cutDetails.hidden);updateWhatsApp();}
    cutting.addEventListener('change',syncCutting); form.addEventListener('input',updateWhatsApp); form.addEventListener('change',updateWhatsApp);
    form.addEventListener('submit',()=>{clearTimeout(timer);searchController?.abort();closeResults();});
    document.addEventListener('click',e=>{if(!root.contains(e.target))closeResults();});
    syncCutting();
  }
  const start = () => document.querySelectorAll('[data-special-order]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();
})();
